/** 日期栏多时间段：第一段同步 startDate/endDate；多段固定并集 */

export const STATISTICS_DATE_PERIOD_MAX = 3;

const emptyPeriod = () => ({ startDate: null, endDate: null });

/** @returns {{ startDate: *, endDate: * }[]} */
export const resolveStatisticsDatePeriods = (filters = {}) => {
	const raw = Array.isArray(filters.datePeriods) ? filters.datePeriods.filter(Boolean) : null;
	if (raw?.length) {
		return raw.map((period) => ({
			startDate: period?.startDate ?? null,
			endDate: period?.endDate ?? null,
		}));
	}
	return [emptyPeriod()];
};

const syncPrimaryFromPeriods = (periods, patch = {}) => {
	const primary = periods[0] ?? emptyPeriod();
	const next = {
		...patch,
		datePeriods: periods,
	};
	if (primary.startDate && primary.endDate) {
		next.startDate = primary.startDate;
		next.endDate = primary.endDate;
	}
	return next;
};

/** 更新某一段 */
export const buildDatePeriodUpdatePatch = (filters, index, rangePatch) => {
	const periods = resolveStatisticsDatePeriods(filters);
	if (index < 0 || index >= periods.length) return {};
	const nextPeriods = periods.map((period, i) =>
		i === index
			? {
					startDate: 'startDate' in rangePatch ? rangePatch.startDate : period.startDate,
					endDate: 'endDate' in rangePatch ? rangePatch.endDate : period.endDate,
				}
			: period,
	);
	const restPatch = { ...rangePatch };
	delete restPatch.startDate;
	delete restPatch.endDate;
	return {
		...syncPrimaryFromPeriods(nextPeriods, {
			...restPatch,
		}),
	};
};

/** 追加空时间段（多段下单日取并集） */
export const buildAddDatePeriodPatch = (filters) => {
	const periods = resolveStatisticsDatePeriods(filters);
	if (periods.length >= STATISTICS_DATE_PERIOD_MAX) return {};
	return syncPrimaryFromPeriods([...periods, emptyPeriod()]);
};

/** 删除某一段 */
export const buildRemoveDatePeriodPatch = (filters, index) => {
	const periods = resolveStatisticsDatePeriods(filters);
	if (periods.length <= 1 || index < 0 || index >= periods.length) return {};
	return syncPrimaryFromPeriods(periods.filter((_, i) => i !== index));
};

/** 起止都有值的时间段（供摘要 / 查询） */
export const resolveFilledStatisticsDatePeriodQuery = (filters = {}) => {
	const filled = resolveStatisticsDatePeriods(filters).filter((period) => period?.startDate && period?.endDate);
	return { periods: filled };
};
